import { cn } from '@/libs/utils';

export default function ToggleHeader({ title, children, className, metadata }) {
  return (
    <header
      className={cn(
        'flex select-none items-center justify-between gap-4',
        className
      )}
    >
      <p className={cn('font-semibold', metadata?.labelClassName)}>{title}</p>

      {children}
    </header>
  );
}
